import { connectModal } from "redux-modal";
import BMXCardModal from "../../../../Components/Modals/BMXCardModal/BMXCardModal";
import BMXSelectList from "../../../../Components/BMXSelectList/BMXSelectList";
import "./BMXSelectListModal.scss";

const BMXSelectListModal = (props) => {
    const { handleHide, show, clientX,clientY, data, onClick } = props;

    return (
        <BMXCardModal
            className="BMXSelectListModal"
            left={clientX}
            top={clientY}
            width="max-content"
            height="max-content"        
            open={show}
            onClose={handleHide}
            onOutside={true}
            backgroundDisable={true}
        >
            <BMXSelectList data={data} onClick={onClick} onClose={handleHide}/>
        </BMXCardModal>
    );
};

export default connectModal({ name: "BMXSelectListModal" })(BMXSelectListModal);